/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Run_Onboarding_FlowInputs */

const en_mobile_run_onboarding_flow = /** @type {(inputs: Mobile_Run_Onboarding_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run onboarding flow`)
};

const es_mobile_run_onboarding_flow = /** @type {(inputs: Mobile_Run_Onboarding_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecutar onboarding`)
};

/**
* | output |
* | --- |
* | "Run onboarding flow" |
*
* @param {Mobile_Run_Onboarding_FlowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_run_onboarding_flow = /** @type {((inputs?: Mobile_Run_Onboarding_FlowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Run_Onboarding_FlowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_run_onboarding_flow(inputs)
	return en_mobile_run_onboarding_flow(inputs)
});